// extracted by mini-css-extract-plugin
export default {"Page":"style_Page__XEY93","Head":"style_Head__97HEz","Title":"style_Title__Alm-+","Btn":"style_Btn__-inmG"};